export default "__VITE_ASSET__kWNKyHiQ__"